export default __webpack_public_path__ + "static/media/green-check.7d973994.svg";